import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cutArray',
    standalone: true
})
export class CutArrayPipe implements PipeTransform {

    transform(items: Array<any>, length: number = 20): Array<any> {
        if (!length) return items;

        return items.slice(0, length);
    }
}
